<template>
  <v-icon v-if="item.Matching_Status==='Not Matched'" size="small" color="yellow" title="Not Matched">mdi-code-tags</v-icon>
  <v-tooltip v-else location="top" content-class="bg-black">
    <template v-slot:activator="{ props }">
      <v-btn icon size="x-small" variant="text" v-bind="props">
        <v-icon v-if="item.Matching_Status==='Matched'" size="small" color="green">mdi-check-all</v-icon>
        <v-icon v-else-if="item.Matching_Status==='Discarded'" size="small" color="red-lighten-3">mdi-delete</v-icon>
      </v-btn>
    </template>
    <strong>Status: </strong>{{ item.Matching_Status }}<br/>
    <strong>Date: </strong>{{ moment(item.Matching_TS).format('DD/MM/YYYY h:mm:ss a') }}<br/>
    <strong>Process: </strong>{{ item.Matching_Origin_Process }}<br/>
    <strong>Operator: </strong>{{ item.Matching_Origin_Operator }}<br/>
  </v-tooltip>
</template>

<script setup>
import moment from 'moment'

defineProps({
  item: {
    type: Object,
    required: true
  }
})
</script>

<style>

</style>
